import { getLayoutObjFromName } from './getLayoutObjFromName';

export const getColumns = (settings) => {
  const {
    gridColumns,
    gridColumnsTablet,
    gridColumnsMobile,
    verticalMasonryColumns,
    verticalMasonryColumnsTablet,
    verticalMasonryColumnsMobile,
    layout
  } = settings;

  const { type, view, direction } = getLayoutObjFromName(layout);
  let result = null;
  if (type === 'masonry' && view === 'grid') {
    result = {
      default: gridColumns,
      tablet: gridColumnsTablet,
      mobile: gridColumnsMobile
    };
  } else if (
    type === 'masonry' &&
    view === 'masonry' &&
    direction === 'vertical'
  ) {
    result = {
      default: verticalMasonryColumns,
      tablet: verticalMasonryColumnsTablet,
      mobile: verticalMasonryColumnsMobile
    };
  } else {
    result = {
      default: 0,
      tablet: 0,
      mobile: 0
    };
  }

  return result;
};
